module.exports = __webpack_public_path__ + "img/big1.682ec3cb.jpg";